import { registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { ApplicationConfig } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import {
  DefaultMatCalendarRangeStrategy,
  MatRangeDateSelectionModel,
} from '@angular/material/datepicker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { authenticationProviders } from '@qaroni-core/providers/autenthication.providers';
import { authStorageProvider } from '@qaroni-core/providers/auth.storage.provider';
import { dateFnsAdapterProviders } from '@qaroni-core/providers/date-fns-adapter.provider';
import { snackbarProviders } from '@qaroni-core/providers/snackbar.provider';
import { routes } from './layout/layout.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideNativeDateAdapter(),
    DefaultMatCalendarRangeStrategy,
    MatRangeDateSelectionModel,
    provideHttpClient(withInterceptorsFromDi()),
    authenticationProviders(),
    authStorageProvider(),
    provideRouter(routes),
    provideAnimationsAsync(),
    snackbarProviders(),
    dateFnsAdapterProviders(),
  ],
};

registerLocaleData(localeEs, 'es-ES');
